import React from "react"
import Button from '@react/react-spectrum/Button';
import { Link} from "react-router-dom";

export default function Cards({title}) {
    return (
        <div className = "card">
            <h1 className ="title"> Create a {title} </h1>
            <p className ="description">Short description goes here </p>
            <Link to={{
                    pathname:`/${title}`,
                  }} ><Button id ="cardButton" varient = "cta">Try now </Button></Link>
        </div>
    )
}